<template>
  <div class="body-padding">
    <div class="register">
      <div class="child">
      <!--手机号-->
      <div data-placeholder="请输入手机号" class="input-line">
        <input class="phone" type="tel" v-model="mobile" maxlength="13" placeholder="请输入您的手机号">
      </div>

      <!--验证码-->
      <div class="captcha-wrap">
        <div data-password-placeholder="请输入验证码" class="captcha-line ">
          <h3>请输入短信验证码</h3>
          <div class="is-send">
            <span v-show="count !== 0">已向您的手机 {{mobile.substring(mobile.length - 4)}} 发送验证码</span>
            <div class="send-wrap" :data-disabled="sendDisabled">
              <span v-if="count === 0" class="send-button" @click="handleSendCaptcha">发送验证码</span>
              <span v-else class="send-button">重新发送({{count}})</span>
            </div>
          </div>
          <input
            ref="captcha"
            type="tel"
            v-model="captcha"
            maxlength="4"
            class="invisible-password"
          >
          <p class="letters" @click="handleInputFocus">
            <!-- <span class="placeholder-text">{{captcha.length > 0 ? '' : captchaText}}</span> -->
            <span class="num">{{captcha[0]}}</span>
            <span class="num">{{captcha[1]}}</span>
            <span class="num">{{captcha[2]}}</span>
            <span class="num">{{captcha[3]}}</span>
          </p>
        </div>
      </div>

      <!--密码
      <div data-placeholder="请输入密码" class="input-line">
        <input
          class="password"
          type="password"
          v-model="password"
          maxlength="20"
          placeholder="请输入密码(6~20位英文或数字)"
        >
        <input
          class="password"
          type="password"
          v-model="verify"
          maxlength="20"
          placeholder="请再次输入密码(6~20位英文或数字)"
        >
      </div>

     邀请码-->
      <div data-placeholder="请输入邀请码(非必填)" class="input-line input-line__invite">
        <input
          :disabled="!!this.$route.query.inviteCode"
          class="invite invite-top"
          v-model="inviteCode"
          placeholder="请输入邀请码(非必填)"
        >
      </div>

      <div class="btn-wrap">
        <van-button
          :disabled="loginDisabled"
          class="login-btn"
          size="small"
          type="warning"
          round
          @click="handleRegisterClick"
        >注&nbsp;&nbsp;册&nbsp;&nbsp;并&nbsp;&nbsp;登&nbsp;&nbsp;录</van-button>
      </div>
      <div class="toggle-btn" @click="handleToggle">验证码登录</div>
      <div class="agreement">
        注册即视为同意
        <span @click="agreement">《快递运单契约条款》</span>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { city } from "@/utils/city";
import Cookie from "js-cookie";
export default {
  name: "Register",
  data() {
    return {
      mobile: "",
      password: "123456",
      verify: "123456",
      captcha: "",
      count: 0,
      captchaText: "请输入发送至手机的验证码",
      inviteCode: this.$route.query.inviteCode || "",
      inviteSource: this.$route.query.inviteSource || "",
      lat: 0,
      lng: 0,
      provinceName: "",
      provinceId: "",
      cityName: "",
      cityId: "",
      districtName: "",
      districtId: ""
    };
  },
  watch: {
    mobile(val, oldVal) {
      if (val && isNaN(parseInt(val[val.length - 1]))) {
        console.log(parseInt(val.substring(0, val.length - 1)));
        this.mobile = oldVal;
      }

      if (oldVal.length >= 12) {
        this.mobile = val.replace(/\s+/g, "");
      } else if (val.length === 11) {
        let arr = val.split("");
        arr.splice(7, 0, " ");
        arr.splice(3, 0, " ");
        this.mobile = arr.join("");
      }
    }
  },
  mounted() {
    this.getCurrentPosition();
    // var mo=function(e){e.preventDefault();};
    // document.body.style.overflow='scroll';
  },

  computed: {
    loginDisabled() {
      if (this.mobile.length !== 13) return true;
      return !(
        this.password.length >= 6 &&
        this.password.length <= 20 &&
        this.password === this.verify
      );
    },
    sendDisabled() {
      if (this.mobile.length !== 13) return true;
      return this.count !== 0;
    }
  },
  methods: {
    handleInputFocus() {
      this.$refs.captcha.focus();
    },
    getCurrentPosition() {
      let geolocation = new BMap.Geolocation();
      let geoc = new BMap.Geocoder();
      geolocation.getCurrentPosition(
        r => {
          if (geolocation.getStatus() === BMAP_STATUS_SUCCESS) {
            geoc.getLocation(r.point, rs => {
              let addComp = rs.addressComponents;
              this.provinceName = addComp.province;
              this.cityName = addComp.city;
              this.districtName = addComp.district;
              let code = "";
              Object.entries(city.province_list).forEach(([key, val]) => {
                if (val === this.provinceName) {
                  this.provinceId = key;
                  code = key;
                }
              });
              Object.entries(city.city_list).forEach(([key, val]) => {
                if (
                  key.slice(0, 1) === code.slice(0, 1) &&
                  val === this.cityName
                ) {
                  this.cityId = key;
                }
              });
              Object.entries(city.county_list).forEach(([key, val]) => {
                if (
                  key.slice(0, 3) === code.slice(0, 3) &&
                  val === this.districtName
                ) {
                  this.districtId = key;
                }
              });
            });
          } else {
            this.$toast({
              message: "获取位置信息失败，请刷新后重试",
              duration: 1000
            });
          }
        },
        { enableHighAccuracy: true }
      );
    },
    handleSendCaptcha() {
      if (this.sendDisabled) return;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: "短信发送中...",
        mask: true
      });
      let params = {
        mobile: this.mobile.replace(/\s+/g, "")
      };
      this.$axios({
        url: "user/captcha",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        params
      })
        .then(() => {
          let TIME_COUNT = 60;
          let count = TIME_COUNT;
          this.count = 60;
          this.timer = setInterval(() => {
            if (count > 1 && count <= TIME_COUNT) {
              count--;
              this.count = count;
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.count = 0;
            }
          }, 1000);
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            message: err.data.msg,
            duration: 1000
          });
        });
    },
    handleRegisterClick() {
      let mobile = this.mobile.replace(/\s+/g, "");
      let params = {
        params: {
          mobile: mobile,
          nickname: mobile,
          password: this.password,
          loginType: 5,
          captcha: this.captcha,
          inviteCode: this.inviteCode,
          inviteSource: this.inviteSource,
          gender: 0,
          lat: this.lat,
          lng: this.lng,
          provinceName: this.provinceName,
          provinceId: this.provinceId,
          cityName: this.cityName,
          cityId: this.cityId,
          districtName: this.districtName,
          districtId: this.districtId,
          logisticsCompanyId: this.$logisticsCompanyId
        }
      };
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: "加载中...",
        mask: true
      });
      this.$axios
        .post("user/registry", params)
        .then(() => {
          let params = {
            params: {
              loginType: 5,
              mobile: mobile,
              password: this.password,              
              logisticsCompanyId: this.$logisticsCompanyId
            }
          };
          return this.$axios.post("auth/token", params);
        })
        .then(res => {
          this.loginSuccess(res);
        })
        .catch(err => {
          this.$toast({
            message: err.data.msg,
            duration: 1000
          });
        });
    },
    loginSuccess(res) {
      let mobile = this.mobile.replace(/\s/g, "");
      let data = res.data.data;
      this.userId = data.accid;
      let token = {
        token: data.token_type + " " + data.access_token
      };
      Cookie.set('yhb_token', JSON.stringify(token));
      localStorage.setItem("yhb_token", JSON.stringify(token));
      localStorage.setItem("yhb_phone", mobile);
      localStorage.setItem("yhb_userId", this.userId);
      localStorage.setItem("yhb_rememberPhone", mobile);
      this.$store.commit("getToken");
      this.wxLogin();
    },
    async wxLogin() {
      try {
        let isWxLogin =
          window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !==
          -1;
        if (!isWxLogin) {
          this.$router.push(this.$route.query.redirect || "/user");
          this.$toast.clear();
          return;
        }
        let params = {
          params: {
            userId: this.userId,
            loginType: 5,
            wechatMark: this.$wechatMark
          }
        };
        let openid = await this.$axios.post("weixin/get/openid", params);
        if (openid.data.data) {
          this.$router.push("/preorder");
          return;
        }
        params = {
          params: {
            wechatMark: this.$wechatMark,
            callback: this.$callbackPage
          }
        };
        this.$axios.get("weixin/getCodeUrl", params).then(res => {
          window.location.href = res.data.data;
        });
        this.$toast.clear();
      } catch (err) {
        this.$toast({
          message: err.data.msg,
          duration: 1000
        });
      }
    },
    handleToggle() {
      this.$router.replace({
        name: "Login"
      });
    },
    agreement() {
      this.$router.push("/user/agreement");
    },
  }
};
</script>

<style scoped lang="scss">
.body-padding {
  overflow: hidden;
  // overflow: scroll;
}
.register {
  background-color: #fff;
  height: 100%;
  width: 100%;
  -webkit-overflow-scrolling: touch;
   overflow-y: scroll;
}

.input-line {
  padding-top: 1.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .password,
  .phone,
  .invite {
    /*margin-top: 0.4rem;*/
    line-height: 0.4rem;
    font-size: 0.4rem;
    padding: 0.48rem 0.31rem;
    flex-basis: 0;
    border-bottom: 1px solid #bfbfbf;

    &::-webkit-input-placeholder {
      color: #747474;
      font-size: 0.35rem;
    }

    &[disabled] {
      background: #fff;
    }
  }

  &::after {
    content: attr(data-placeholder);
    position: absolute;
    top: 0.6rem;
    left: 0;
    font-size: 0.53rem;
    padding-left: 0.31rem;
    font-weight: bold;
    color: #4f4f4f;
  }
}

.input-line__invite {
  &:after {
    font-size: 0.3rem;
  }
}

.captcha-line {
  padding-top: 1.5rem;
  position: relative;

  &::after {
    content: attr(data-passwordPlaceholder);
    position: absolute;
    top: 0.6rem;
    left: 0;
    font-size: 0.53rem;
    padding-left: 0.31rem;
    font-weight: bold;
    color: #4f4f4f;
  }

  .is-send {
    font-size: 0.29rem;
    line-height: 0.4rem;
    height: 0.4rem;
    color: #8f8f8f;
    padding-left: 0.31rem;
    position: relative;
    .send-wrap {
      top: 0;
      position: absolute;
      right: 0.31rem;
      color: #fe9329;
      &[data-disabled="true"] {
        color: #8f8f8f;
      }
    }
  }

  .invisible-password {
    padding-left: 0.1rem;
    border: 0;
    bottom: 0;
    position: absolute;
    height: 1.41rem;
    font-size: 0.22rem;
    text-indent: -999rem;
    margin-left: -100%;
  }

  .letters {
    height: 1.41rem;
    font-size: 0.61rem;
    display: flex;
    position: relative;
    align-items: center;
    padding-left: 0.31rem;
    padding-right: 0.31rem;

    .placeholder-text {
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 0.35rem;
      color: #747474;
      height: 1.41rem;
      line-height: 1.41rem;
      padding-left: 0.31rem;
    }

    .num {
      flex: 1;
      height: 1.41rem;
      line-height: 1.41rem;
      text-align: center;
      border-bottom: 2px solid #bfbfbf;

      & ~ .num {
        margin-left: 1.03rem;
      }
    }
  }
}

.btn-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.59rem;

  .login-btn {
    width: 8.83rem;
    height: 0.96rem;
    line-height: 0.96rem;
    text-align: center;
    font-size: 0.4rem;

    &[disabled] {
      color: #ffffff;
      background: #bfbfbf;
    }
  }
}

.toggle-btn {
  color: #fe9329;
  font-size: 0.27rem;
  display: inline-block;
  padding: 0.23rem 0.31rem;
}
.agreement {
  width: 8.83rem;
  font-size: 0.27rem;
  font-family: PingFang-SC-Regular;
  font-weight: bold;
  color: rgba(79, 79, 79, 1);
  margin: auto;
  padding: 0.8rem 0 0.533333rem 0;
}
.agreement > span {
  color: #042d6f;
}
.invite-top.invite{
  padding-top:0rem;
}
.captcha-line>h3{
  padding-left: .266667rem;
  font-size: .533333rem;
  font-weight: 800;
  color:  #4f4f4f;
}
</style>
